<template>
  <div
    :id="$options.consts.ELEMENT_ID.ABOUT_SECTION"
    class="awards-about-section__wrapper full-width-section"
  >
    <div class="awards-about-section__container">
      <p class="awards-about-section__paragraph text-body">
        The Finance Magnates Awards shine a spotlight on the brands and leaders
        shaping the future of finance. This recognition goes beyond titles; it
        reflects innovation, leadership, and industry impact.
      </p>

      <p class="awards-about-section__paragraph text-body">
        For B2C<b> brokerage brands</b>, it represents a commitment to
        excellence, setting higher standards in service, transparency, and
        client experience. For <b>B2B fintech brands</b>, this recognition
        signifies leadership in showcasing the development of innovative
        solutions that drive the financial industry forward.
      </p>

      <p class="awards-about-section__paragraph text-body">
        Winning a Finance Magnates Award is a sign of trust and credibility. It
        shows that your peers, clients, and competitors recognise your impact
        and leadership in the industry. This award reinforces your reputation
        and sets you apart as a company that drives real progress in finance.
      </p>
    </div>
  </div>
</template>

<script>
import { ELEMENT_ID } from 'enums/element-id'

export default {
  name: 'AwardsAboutSection',
  consts: { ELEMENT_ID }
}
</script>

<style lang="scss" scoped>
.awards-about-section__wrapper {
  position: relative;
  z-index: 1;
  background-color: $c--background-dark-2;

  .awards-about-section__container {
    max-width: $desktop-container;

    $padding: (
      $above-desktop-xl: 64px $padding-x-desktop-full-hd,
      $desktop-sm: 64px $padding-x-desktop-sm,
      $mobile: 32px $padding-x-mobile
    );

    @include setStyleByBreakpoint('padding', $padding);

    .awards-about-section__paragraph {
      margin-bottom: 14px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
